import logger from "@next/core-logger"
import type {AxiosError} from "axios"

import axios from "../../utils/axios"
import {ColourwayData} from "../../models/searchApi"
import SearchApi from "../../config/api/search"

export const getSiteUrl = () => {
    // Example siteUrls that should be handled
    // https://www.next.de/de/search?w=*
    // https://sxeun-test.next.co.uk/dev04/shop/xyz

    let siteUrl = ""
    if (window.location.href.split("/search").length === 2) {
        ;[siteUrl] = window.location.href.split("/search")
    }
    if (window.location.href.split("/shop").length === 2) {
        ;[siteUrl] = window.location.href.split("/shop")
    }

    if (window.location.href.split("/sale").length === 2) {
        ;[siteUrl] = window.location.href.split("/sale")
    }

    if (window.location.href.split("/clearance").length === 2) {
        ;[siteUrl] = window.location.href.split("/clearance")
    }

    return siteUrl
}

export const getColourways = async (
    headers: any,
    itemNumber: string | number,
    type: string,
): Promise<{response: ColourwayData[]; responseHeaders}> => {
    try {
        const getProductSummaryDataApi = SearchApi("getColourwaySummary")

        const response = await axios({
            method: getProductSummaryDataApi.method,
            url: `${getSiteUrl()}/product-summary/${type}/colourways/${itemNumber}`,
            headers,
        })

        return {
            response: response.data,
            responseHeaders: response.headers,
        }
    } catch (err) {
        const error = err as AxiosError
        if (error.response) {
            // Axios interceptors log this error already
            throw error
        }
        logger.error(error)
        throw error
    }
}
